import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import type StoreService from 'scaleflow/services/store';
import type RouterService from '@ember/routing/router-service';

import { service } from '@ember/service';
import { action } from '@ember/object';

type Params = {
  scan_id: string;
};
class ScansScanRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;

  model({ scan_id }: Params) {
    return this.store.findRecord('scan', scan_id, {
      include: 'all',
      reload: true,
    });
  }

  afterModel(scan: any) {
    if (scan.status !== 'COMPLETED') {
      this.router.replaceWith('scans.scan.processing', scan.id as string);
    }
  }

  @action
  error(error: any) {
    if (error.code === 'NotFoundError') {
      this.router.replaceWith('scans.list');
      return;
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }
}

export default instrumentRoutePerformance(ScansScanRoute);
